<template>
  <span
    >Add {{ action.points }} points to guest</span
  >
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["action"],
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters({
      actionStyling: "automations/actionStyling",
    }),
  },
  async mounted() {},
};
</script>

<style lang="scss">
</style>